import { defineStore } from "pinia";
import axios from "@/plugins/axios"; // Tu instancia de Axios configurada

export const useUserStore = defineStore("user", {
  state: () => ({
    user: null,
    users: [], 
    token: localStorage.getItem("userToken") || null,
  }),
  actions: {
    async fetchUser() {
      if (!this.token) return; // Si no hay token, no intentes validar

      try {
        const response = await axios.post("/user-authenticated"); // Endpoint para validar y obtener datos del usuario
        this.user = response.data;
      } catch (error) {
        console.error("Error fetching user:", error);
        this.logout(); // Limpia estado si la validación falla
      }
    },
    async fetchUsers() {
      if (!this.token) return; // Si no hay token, no intentes validar

      try {
        const response = await axios.post("/users"); // Endpoint para validar y obtener datos del usuario
        this.users = response.data;
      } catch (error) {
        console.error("Error fetching users:", error);
        this.logout(); // Limpia estado si la validación falla
      }
    },
    
    // Agregar una nuevo usuario
    async addUser(user) {
      try {
        const response = await axios.post('/user-system', user);
        this.users.push(response.data); // Agregar la nueva empresa a la lista
      } catch (error) {
        console.error('Error adding center:', error.message);
        throw error;
      }
    },


    // Actualizar un usuario
    async updateUser(user) {
      try {
        const response = await axios.put(`/user-system/${user.id}`, user);
        // Actualizar la empresa en la lista
        const index = this.users.findIndex((c) => c.id === user.id);
        if (index!== -1) {
          this.users[index] = response.data;
        }
      } catch (error) {
        console.error('Error updating user:', error.message);
        throw error;
      }
    },


    // Eliminar un usuario
    async deleteUser(id) {
      try {
        const response = await axios.delete(`/user-system/${id}`);
        return response.data;
      } catch (error) {
        console.error('Error deleting user:', error.message);
        throw error;
      }
    },

    async logout() {
      try {
          // Llamada al backend para revocar el token
          await axios.post('/auth/logout-user');
  
          // Limpiar el estado local
          this.user = null;
          this.token = null;
          localStorage.removeItem("user");
          localStorage.removeItem("userToken");
  
          // Opcional: Redirigir al usuario a la pantalla de login
          window.location.href = "/login";
      } catch (error) {
          console.error("Error al cerrar sesión:", error.message);
      }
  },
  },
});
